import React from 'react';

export default function Dashboard() {
  return (
    <div>
      <h1>DASHBOARD</h1>
    </div>
  );
}
